import { render } from "./BorderTime.vue?vue&type=template&id=04d664a5&scoped=true"
import script from "./BorderTime.vue?vue&type=script&lang=js"
export * from "./BorderTime.vue?vue&type=script&lang=js"

import "./BorderTime.vue?vue&type=style&index=0&id=04d664a5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04d664a5"

export default script